<script>
export default {
    name: "login-container"
}
</script>

<template>
    <div class="login-container">
        <slot/>
    </div>
</template>

<style scoped>
    .login-container {
        overflow-y: auto !important;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
    }
</style>
